"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _useCurrentState = _interopRequireDefault(require("../use-current-state"));

const useModal = (initialVisible = false) => {
  const [visible, setVisible, currentRef] = (0, _useCurrentState.default)(initialVisible);
  return {
    visible,
    setVisible,
    currentRef,
    bindings: {
      open: visible,
      onClose: () => setVisible(false)
    }
  };
};

var _default = useModal;
exports.default = _default;
module.exports = exports.default;